interface RoleRef {
  id: number
  lutOrder?: number
}

export function groupStaffersByRole<T extends { displayOrder?: number | null }> (
  staffers: T[],
  roleOf: (staffer: T) => RoleRef | null | undefined
): Array<[number, T[]]> {
  const byRole = new Map<number, T[]>()
  const sorted = [...staffers].sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
  for (const staffer of sorted) {
    const roleId = roleOf(staffer)?.id ?? 0
    const group = byRole.get(roleId) ?? []
    group.push(staffer)
    byRole.set(roleId, group)
  }
  return Array.from(byRole.entries()).sort(
    ([, a], [, b]) => (roleOf(a[0])?.lutOrder ?? 0) - (roleOf(b[0])?.lutOrder ?? 0)
  )
}
